(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/tickets-row-wrapper.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/tickets-row-wrapper.js');
"use strict";


const _React = React,
  Fragment = _React.Fragment;
const TicketsRowWrapper = _ref => {
  let category = _ref.category;
  const _svs$eInstant$shared$ = svs.eInstant.shared.components,
    DesktopPagination = _svs$eInstant$shared$.DesktopPagination,
    CategoryTicketsWheel = _svs$eInstant$shared$.CategoryTicketsWheel;
  return React.createElement(Fragment, null, React.createElement(CategoryTicketsWheel, {
    category: category
  }), React.createElement(DesktopPagination, {
    category: category
  }));
};
setGlobal('svs.eInstant.shared.components.TicketsRowWrapper', TicketsRowWrapper);

 })(window);